import { populateSEO } from "@shared/lib";
import { EmployerPage, PageData, WidgetsComponent } from "../types";
import { ApiInstance } from "./instance";

const populateMeta = {
  indexPageMeta: {
    populate: ["emptyScreen"]
  },
  companyDetailPageMeta: {
    populate: ["vacancyEmptyScreen"]
  },
  governmentIndexPageMeta: {
    populate: ["emptyScreen"]
  },
  governmentDetailPageMeta: {
    populate: ["vacancyEmptyScreen"]
  },
  vacancyCard: {
    populate: ["salaryInfo", "platformInfo.defaultPlatformLogo"],
  },
}

export class EmployerPageApi extends ApiInstance {
  constructor(locale = "id-ID") {
    super(locale);
  }

  getEmployerPageData(): Promise<PageData<EmployerPage>> {
    const query = {
      populate: {
        contents: {
          on: {
            [WidgetsComponent.CommonHeroSection]: {
              populate: [
                "imageDesktop",
                "imageMobile",
                "backgroundMobile",
                "subtitle.icon",
                "button.color",
                "button.icon",
              ]
            },
            [WidgetsComponent.CommonBentoGridSection]: {
              populate: [
                "button.color",
                "button.icon",
                "grids.cards",
                "grids.cards.subtitle.icon",
                "grids.cards.image",
                "grids.cards.backgroundImage",
                "grids.cards.button.icon",
                "grids.cards.button.color",
              ],
            },
            [WidgetsComponent.CommonGridSection]: {
              populate: [
                "subtitle.icon",
                "cards",
                "cards.image",
              ],
            },
            [WidgetsComponent.FaqSection]: {
              populate: [
                "subtitle.icon",
                "footLink.icon",
                "footLink.color",
                "faqs",
              ],
            },
            [WidgetsComponent.EmployerCta]: {
              populate: [
                "button.icon",
                "button.color",
                "backgroundDesktop",
                "backgroundMobile",
              ],
            },
          },
        },
        ...populateSEO,
        ...populateMeta,
      }
    };

    return this._SendWithQuery("/employer-page", query);
  }

  getEmployerPageDataWithoutContents(): Promise<PageData<EmployerPage>> {
    const query = {
      populate: {
        ...populateSEO,
        ...populateMeta,
      },
    };

    return this._SendWithQuery("/employer-page", query);
  }
}
